module.exports = __webpack_public_path__ + "static/media/sf_2300.e46104b30dd4cd93fb58f3f361fccf4f.png";